import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-green-400 text-white hover:bg-green-400/90',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        // Status colors mirroring the legacy reactstrap badge palette
        info: 'border-transparent bg-blue-100 text-blue-400',
        success: 'border-transparent bg-green-100 text-green-400',
        danger: 'border-transparent bg-red-100 text-red-400',
        progress: 'border-transparent bg-yellow-100 text-yellow-550',
        disabled: 'border-transparent bg-gray-blue-5 text-gray-blue-60',
        refund: 'border-transparent bg-purple-100 text-purple-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
